import {NgModule,} from '@angular/core';
import {Route, RouterModule,} from '@angular/router';
import {ScreenVO,} from '@models/system-vo/screen-vo';
//import {AuthGuard,} from '@services/index';
import {NotFoundComponent,} from '@pages/notfound/not-found.component';
import {NotAuthorizedComponent,} from '@pages/not-authorized/not-authorized.component';
//import {ViewPdfWindow,} from '@pages/common-component/view-pdf-window/view-pdf-window.component';

// TODO ToolGen: place import components above here
import {SMS000Main,} from '@pages/sms000-main/sms000-main';
import {SMS001MainMenu,} from '@pages/sms001-main-menu/sms001-main-menu';
import {SMS002KeiyakuInfo,} from '@pages/sms002-keiyaku-info/sms002-keiyaku-info';
import {SMS003SiharaiEntry,} from '@pages/sms003-siharai-entry/sms003-siharai-entry';
import {SMS004BarcodeLink,} from '@pages/sms004-barcode-link/sms004-barcode-link';
import {SMS005KozaInfo,} from '@pages/sms005-koza-info/sms005-koza-info';
import {SMS006SeikyugakuInfo,} from '@pages/sms006-seikyugaku-info/sms006-seikyugaku-info';
import {SMS007KaiyakuEntry,} from '@pages/sms007-kaiyaku-entry/sms007-kaiyaku-entry';
import {SMS008KingakuInfo,} from '@pages/sms008-kingaku-info/sms008-kingaku-info';
import {SMS009NameUpdate,} from '@pages/sms009-name-update/sms009-name-update';
import {SMS010Completed,} from '@pages/sms010-completed/sms010-completed';
import {SMS011Error,} from '@pages/sms011-error/sms011-error';

export const SCREEN_DEFINITIONS: (Route | ScreenVO)[] = [
  {path: '', redirectTo: 'pages/sms000-main', pathMatch: 'full',},
  {screenId: 'SMS000', screenName: '接続メイン', path: 'pages/sms000-main', component: SMS000Main, forceHideMenu: true,},
  {screenId: 'SMS001', screenName: 'メインメニュー', path: 'pages/sms001-main-menu', component: SMS001MainMenu, forceHideMenu: true,},
  {screenId: 'SMS002', screenName: '契約情報', path: 'pages/sms002-keiyaku-info', component: SMS002KeiyakuInfo, forceHideMenu: true,},
  {screenId: 'SMS003', screenName: '現在残高・支払希望日', path: 'pages/sms003-siharai-entry', component: SMS003SiharaiEntry, forceHideMenu: true,},
  {screenId: 'SMS004', screenName: 'コンビニ収納サービス', path: 'pages/sms004-barcode-link', component: SMS004BarcodeLink, forceHideMenu: true,},
  {screenId: 'SMS005', screenName: '家賃残高・振込口座確認', path: 'pages/sms005-koza-info', component: SMS005KozaInfo, forceHideMenu: true,},
  {screenId: 'SMS006', screenName: '請求金額確認', path: 'pages/sms006-seikyugaku-info', component: SMS006SeikyugakuInfo, forceHideMenu: true,},
  {screenId: 'SMS007', screenName: '解約・退去予定日登録', path: 'pages/sms007-kaiyaku-entry', component: SMS007KaiyakuEntry, forceHideMenu: true,},
  {screenId: 'SMS008', screenName: '請求金額詳細', path: 'pages/sms008-kingaku-info', component: SMS008KingakuInfo, forceHideMenu: true,},
  {screenId: 'SMS009', screenName: '氏名変更登録', path: 'pages/sms009-name-update', component: SMS009NameUpdate, forceHideMenu: true,},
  {screenId: 'SMS010', screenName: '', path: 'pages/sms010-completed', component: SMS010Completed, forceHideMenu: true,},
  {screenId: 'SMS011', screenName: '', path: 'pages/sms011-error', component: SMS011Error, forceHideMenu: true,},

  // TODO ToolGen: place define screen above here
//  {screenId: 'VIEWPDF', screenName: 'PDFファイルリーダー', path: 'pages/view-pdf-window/:key', width: 1675, height: 1040, canActivate: [AuthGuard,], component: ViewPdfWindow,},
  {screenId: 'NOTAUTHORIZED', screenName: '画面表示権限なし', path: 'pages/not-authrized', component: NotAuthorizedComponent, forceHideMenu: true,},
  {screenId: 'NOTFOUND', screenName: '見つかりません', path: '**', component: NotFoundComponent, forceHideMenu: true,},
];

@NgModule({
  imports: [
    RouterModule.forRoot(SCREEN_DEFINITIONS, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule,],
})
export class AppRoutingModule { }
